import { memo } from 'react'
import styled from 'styled-components'
import icInstagram from 'assets/images/icInstagram.svg'
import logoAstro from 'assets/images/AstroResi.svg'
import grabmart from 'assets/images/grabmart.png'
import { Box, Typography } from '@astro-ui/components'

import { receiptSize } from './layout'

type HeaderPropsType = {
  orderType: string
}

function Header({ orderType }: HeaderPropsType) {
  return (
    <HeaderContainer>
      <LogoContainer>
        <LogoAstro src={logoAstro} />
        {orderType === 'GRAB_MART' && <LogoAstro src={grabmart} />}
      </LogoContainer>

      <LogoContainer>
        <Box display="flex" flexDirection="row" alignItems="center" gap={receiptSize(4)}>
          <IGIcon src={icInstagram} />
          <Typography
            color="pureBlack"
            fontSize={receiptSize(17)}
            lineHeight={1.5}
            fontWeight={600}
          >
            @astronauts.id
          </Typography>
        </Box>
      </LogoContainer>
    </HeaderContainer>
  )
}

export default memo(Header)

const HeaderContainer = styled.div`
  width: 100%;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  overflow: hidden;
`

const LogoContainer = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 3mm;
`

const LogoAstro = styled.img`
  width: 17.85mm;
  max-height: 7mm;
  object-fit: contain;
  height: auto;
`
const IGIcon = styled.img`
  height: 4.08mm;
  width: auto;
`
